module.exports = __webpack_public_path__ + "static/dtdl-be22de9290b683e619b22b317e8dda74.png";